import server from "@/utils/request";

// 获取客服信息
export function getKefuInfo(source = 'pc') {
    return server({ method: "GET", url: "/api/Kefu/getKefuInfo", params: { source } });
}

export function getKefuConfig() {
    return server({ method: "GET", url: "/api/Kefu/config" });
}

export function markWelcomeCardShown(data = {}) {
    return server({ method: "POST", url: "/api/Kefu/markWelcomeCardShown", data: { source: 'pc', ...data } });
}

// 获取聊天记录
export function getChatHistory(kefu_uid, page = 1, limit = 20) {
    return server({ method: "GET", url: "/api/Kefu/getChatHistory", params: { kefu_uid, page, limit, source: 'pc' } });
}

// 发送消息（HTTP兆底）
export function sendMessage(to_uid, msn, msn_type = 1, extra = {}) {
    return server({ method: "POST", url: "/api/Kefu/send", data: { to_uid, msn, msn_type, source: 'pc', ...extra } });
}

// 标记已读
export function markRead(kefu_uid) {
    return server({ method: "POST", url: "/api/Kefu/markRead", data: { kefu_uid, source: 'pc' } });
}

export function getUnreadCount(source = 'pc') {
    return server({ method: "GET", url: "/api/Kefu/getUnreadCount", params: { source } });
}

// 提交投诉建议
export function submitFeedback(data) {
    return server({ method: "POST", url: "/api/Kefu/feedback", data });
}

// 我的投诉建议列表
export function getMyFeedbackList(page = 1, limit = 10) {
    return server({ method: "GET", url: "/api/Kefu/myFeedbackList", params: { page, limit } });
}

// 投诉建议详情
export function getFeedbackDetail(id) {
    return server({ method: "GET", url: "/api/Kefu/feedbackDetail", params: { id } });
}

// 追加投诉建议
export function appendFeedback(data) {
    return server({ method: "POST", url: "/api/Kefu/appendFeedback", data });
}

// 获取自动回复
export function getAutoReply(keyword, kefuUid) {
    return server({ method: "POST", url: "/api/Kefu/autoReply", data: { keyword, kefu_uid: kefuUid, source: 'pc' } });
}

// 保存离线反馈消息到数据库
export function saveOfflineFeedback(kefu_uid, message) {
    return server({ method: "POST", url: "/api/Kefu/offlineFeedback", data: { kefu_uid, message, source: 'pc' } });
}
